<template>
    <div>

        <div class="container">
            <img :src="require('@/assets/img/logos/product/custom.png')" title="custom" class="img-logo" />

            <p class="q-mt-sm">
                Avenir Software Inc. has been developing custom software applications for the HVAC and Plumbing industry since 1993.
                We can provide our clients with both Web-based applications and Desktop programs to best serve their specific needs.
            </p>

            <p>
                Our specialty is working with technical products that typically require application design and sizing calculations as part of the selection and specification process.
                Our development team includes Mechanical, Chemical and Software Engineers, with experience in a variety of industries.
                This unique combination means that we already understand your products and applications, saving you valuable time and resources.
            </p>

            <p>
                With our extensive experience in developing modules for application load sizing, project handling, product selection, materials lists, and submittals, we don't need to "reinvent the wheel" for each new program.
                This allows us to focus more of our development efforts on the clients' product-specific needs and unique requirements, ensuring that they get a better software, developed faster and at a lower cost.
            </p>

            <p>
                <router-link to="/contact">Contact us</router-link> to discuss how we can develop a custom software to enhance your technical marketing and sales efforts.
            </p>

            <div class="row">
                <q-btn label="Contact Us" to="/contact" color="primary" class="col-xs-12 col-sm-auto" />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'custom',
        data() {
            return {

            }
        },

    }
</script>
<style lang="scss" scoped>
    @import "../../styles/quasar.variables.scss";

    @media (max-width: $breakpoint-xs-max) {
        .img-logo {
            max-height: 50px;
        }
    }
</style>
